import type { UserBasicInfo } from "@common/client"
import { cn } from "@common/lib/utils"

const COLOURS = [
  "bg-semantic-info-soft text-semantic-info",
  "bg-semantic-success-soft text-semantic-success",
  "bg-semantic-warning-soft text-semantic-warning",
  "bg-brand-lavender text-brand-indigo",
]

type NamedUser = Pick<UserBasicInfo, "first_name" | "last_name">

function colour(user: NamedUser): string {
  const code =
    (user.first_name.charCodeAt(0) || 0) + (user.last_name.charCodeAt(0) || 0)
  return COLOURS[code % COLOURS.length]
}

export function UserInitials({
  user,
  title,
  className,
}: {
  user: NamedUser
  title?: string | null
  className?: string
}): React.ReactElement {
  const full = `${user.first_name} ${user.last_name}`.trim()
  const initials =
    `${user.first_name[0] ?? ""}${user.last_name[0] ?? ""}`.toUpperCase()

  return (
    <div
      title={title === null ? undefined : (title ?? full)}
      className={cn(
        "size-5 shrink-0 rounded-full flex justify-center items-center text-tiny-medium",
        colour(user),
        className,
      )}
    >
      {initials}
    </div>
  )
}
